import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>AMXL Prf Problem Solving</h2>
  <h3>Description</h3>
  <p>This exception is raised when a shipment item is close to its CPT while in a Rodeo work pool state of 'Problem Solving' thus at risk of becoming rolled freight</p>
  <h3>SOP</h3>
  <ul>
    <li>Check if unit is in POPS area
      <ul>
        <li>Yes, move to step #6</li>
      </ul>
    </li>
    <li>Check which SLAM station packed unit. Can be checked through Outer Scannable ID column in rodeo</li>
    <li>Engage SLAMer at that station in effort to locate package</li>
    <li>Unit found?
      <ul>
        <li>Yes, move to step #6</li>
        <li>No, check in Sp00 or tote. DO NOT scan ASIN when prompted to do so in order to "short" unit. Move to step #5</li>
      </ul>
    </li>
    <li>Process through send runner process</li>
    <li>Check in tote or Sp00</li>
    <li>Pack from POPS shipment</li>
    <li>SLAM unit and immediately load on appropriate pallet/trailer</li>
  </ul>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_PRF_PROBLEM_SOLVING.jsx